<template>
  <a-drawer
    :title="`《${textbook.title}》`"
    width="90%"
    placement="right"
    :visible="visible"
    @close="onClose">
    <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-row>
        <a-col span="6">
          <a-form-model-item label="院校">
            <a-select
              :value="queryParam.companyId"
              placeholder="请输入班级名查询"
              style="width: 100%"
              @change="changeCompanyId">
              <a-select-option v-for="company in companyList" :key="company.id">
                {{ company.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item label="班级">
            <a-select
              :value="queryParam.dingOrgId"
              placeholder="请输入班级名查询"
              style="width: 100%"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              @change="handleChangeDingOrgId">
              <a-select-option v-for="clazz in clazzList" :key="clazz.id">
                {{ clazz.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <a-card title="教材总体统计">
      <a-row>
        <a-col span="6" v-for="statistic in statistics" :key="statistic.code">
          <a-statistic :title="statistic.name" :suffix="statistic.unitLabel">
            <span slot="formatter" @click="() => showRank(statistic)">{{statistic.formatValue}}</span>
          </a-statistic>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="教材分章节统计" style="margin-top: 16px;">
      <a-list item-layout="horizontal" style="margin-top: 16px;">
        <a-list-item v-for="groupedStatistic in groupedStatistics" :key="groupedStatistic.id">
          <a-list-item-meta>
            <a slot="title">{{ groupedStatistic.serialName + groupedStatistic.title }}</a>
          </a-list-item-meta>
          <a-row style="width: 80%;">
            <a-col span="4" v-for="statistic in groupedStatistic.statistics" :key="statistic.code">
              <a-statistic :title="statistic.name" :suffix="statistic.unitLabel">
                <span slot="formatter" @click="() => showRank(statistic, groupedStatistic.id)">{{statistic.formatValue}}</span>
              </a-statistic>
            </a-col>
          </a-row>
        </a-list-item>
      </a-list>
    </a-card>
    <a-modal width="60%" v-model="rankingVisible" :title="rankingTitle + '排名'">
      <a-table :columns="columns" :data-source="list">
      </a-table>
    </a-modal>
  </a-drawer>
</template>

<script>
import TextBookApi from '@/api/src/textbook/api/TextBookApi'
import TextbookStatApi from '@/api/src/statistics/api/TextbookStatApi'
import DictApi from '@/api/src/basic/api/DictApi'
const textBookApi = new TextBookApi();
const textbookStatApi = new TextbookStatApi()
const dictApi = new DictApi()

const columns = [
  {
    title: '学生姓名',
    dataIndex: 'name',
  },{
    title: '电话',
    dataIndex: 'phoneNum',
  },{
    title: '视频时长',
    dataIndex: 'formatValue',
  }
];

export default {
  name: 'StaticDetail',
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      rankingVisible: false,
      visible: false,
      textbookId: undefined,
      textbook: {},
      queryParam: {
        companyId: undefined,
        dingOrgId: 552814017
      },
      statistics: [],
      groupedStatistics: [],
      companyList: [],
      clazzList: [],
      columns: columns,
      list: [],
      rankingTitle: undefined
    }
  },
  methods: {
    async open(textbookId) {
      console.log(textbookId)
      this.textbookId = textbookId
      await this.getCompanyList()
      await this.findTextBook()
      this.visible = true
    },
    async getCompanyList() {
      let resp = await dictApi.getCompany()
      console.log(resp)
      this.companyList = resp
    },
    async findTextBook() {
      let resp = await textBookApi.findTextBookById(this.textbookId)
      console.log(resp)
      this.textbook = resp
    },
    async getUsedDingOrgList() {
      // let resp = await textbookStatApi.getUsedDingOrgList()
    },
    async changeCompanyId(companyId) {
      this.queryParam.companyId = companyId
      let resp = await textbookStatApi.getUsedDingOrgList(this.textbookId, companyId)
      this.clazzList = resp
      let resp2 = await textbookStatApi.getTextbookStat(this.textbookId, this.queryParam.dingOrgId)
      console.log(resp2)
      this.statistics = resp2.statistics
      let resp3 = await textbookStatApi.getTextbookGroupedStat(this.textbookId, this.queryParam.dingOrgId, {})
      console.log(resp3)
      this.groupedStatistics = resp3.groupedStatistics
    },
    async handleChangeDingOrgId(dingOrgId) {
      this.queryParam.dingOrgId = dingOrgId
    },
    async showRank({code, name}, unitId) {
      this.rankingTitle = name
      let resp = await textbookStatApi.getStudentsRanking(1, code, this.textbookId, this.queryParam.dingOrgId, {unitId: unitId})
      this.list = resp.list
      this.columns[2].title = name
      this.rankingVisible = true
    },
    onClose() {
      console.log('onClose')
      this.visible = false
    },
    async handleSearch(value) {
      console.log(value)
    },
    async handleChange(clazzId) {
      this.queryParam.clazzId = clazzId
    }
  }
}
</script>

<style>

</style>